import {inject, Injectable} from '@angular/core';
import {ServiceCase} from '../../service-case/models/service-case';
import {UserData} from '../../user/models/user-data';
import {UserService} from '../../user/services/user.service';
import {VehicleWarningLoader} from '../../vehicle-warning/services/vehicle-warning.loader';
import {VehicleServiceContract} from '../interfaces/vehicle-service-contract';
import {ServiceContractService} from './service-contract.service';

@Injectable({
  providedIn: 'root'
})
export class ServiceContractLoader {
  private readonly serviceContractService: ServiceContractService = inject(ServiceContractService);
  private readonly userService: UserService = inject(UserService);
  private readonly vehicleWarningLoader: VehicleWarningLoader = inject(VehicleWarningLoader);

  loadServiceContractsInServiceCase(serviceCase: ServiceCase): Promise<boolean> {
    if (!serviceCase.getVinLong()) {
      return Promise.resolve(this.updateServiceContractsInServiceCase(serviceCase, null));
    }

    const user: UserData = this.userService.getCurrentUser();
    return new Promise(resolve => {
      this.serviceContractService.getServiceContracts(
          serviceCase.getVinLong(),
          user.getLocale(),
          user.getB2XCountryCode(),
          user.getBusinessPartner()
        )
        .then((serviceContracts: VehicleServiceContract[]) => resolve(this.updateServiceContractsInServiceCase(
            serviceCase,
            serviceContracts
          ))
        )
        .catch(errors => {
          this.logBackendErrors(errors);
          resolve(this.updateServiceContractsInServiceCase(serviceCase, undefined));
        });
    });
  }

  private updateServiceContractsInServiceCase(serviceCase: ServiceCase,
                                              serviceContracts: VehicleServiceContract[]): boolean {
    serviceCase.setServiceContracts(serviceContracts);
    return this.vehicleWarningLoader.addServiceContractWarningsToServiceCase(serviceCase);
  }

  private logBackendErrors(errors: any[]): void {
    errors?.forEach((error: any) => console.log(error.message));
  }
}
